import React from "react";

import useComponents from "../../../components";
import useControllers from "../../../../controllers";
import useIcons from "../../../../assets/icons";
import { StyledSearch } from "./SettingsView.styles";

const SettingsView = () => {
  const { IconSearch, IconDelete } = useIcons();

  const {
    ContentWrappers,
    TableContent,
    TableRow,
    useButtons,
    useModals,
    TextFieldControlled,
    Pagination,
    Typography,
    Dropdown,
  } = useComponents();

  const { DefaultButton } = useButtons();
  const { DefaultModal } = useModals();

  const { useScreenHooks } = useControllers();
  const { useSettings } = useScreenHooks();
  const { useSettingsView } = useSettings();
  const {
    control,
    listSettings,
    handleCreateNewSetting,
    handleEditSetting,
    handleRemoveSetting,
    handleCloseModal,
    handleConfirmDelete,
    paginationSettings,
    handlePagination,
    onChangeSearch,
    modalDelete,
    formatContent,
  } = useSettingsView();

  return (
    <div className="bg-white px-8 pt-10 pb-12 mx-12 rounded-lg">
      <ContentWrappers
        gridColums={["1fr 210px"]}
        className="mb-8 items-center border-b border-neutral-60 pb-8"
      >
        <Typography variant="h3" className="uppercase">
          Listado de Settings
        </Typography>
        <DefaultButton
          color="secondary"
          onClick={handleCreateNewSetting}
        >
          Crear Nuevo Setting
        </DefaultButton>
      </ContentWrappers>

      <ContentWrappers gridColums={["1fr"]} className="mb-10">
        <StyledSearch>
          <TextFieldControlled
            placeholder="Buscar por ID"
            name="search"
            id="search"
            control={control}
            onInputChange={onChangeSearch}
          />
          <button type="button">
            <IconSearch />
          </button>
        </StyledSearch>
      </ContentWrappers>

      <TableContent
        headerCellList={["ID", "Contenido", "Última actualización", "Acciones"]}
        gridCell={["1fr", "1.5fr", "1fr", "120px"]}
      >
        {listSettings.length > 0 ? (
          listSettings.map((setting, index) => (
            <TableRow key={index}>
              <div className="font-medium">{setting.id}</div>
              <div className="truncate" title={formatContent(setting.content, setting.id)}>
                {formatContent(setting.content, setting.id)}
              </div>
              <div>{new Date(setting.updated_at).toLocaleString("es-ES")}</div>
              <div className="flex justify-end">
                <Dropdown
                  options={[
                    { id: 'edit', action: () => handleEditSetting(setting) },
                    { id: 'delete', action: () => handleRemoveSetting(setting.id, setting.id) },
                  ]}
                />
              </div>
            </TableRow>
          ))
        ) : (
          <div>Sin datos para mostrar</div>
        )}
      </TableContent>

      <Pagination
        onPageChange={handlePagination}
        pageCount={paginationSettings.totalPages}
      />

      <DefaultModal
        isOpen={modalDelete.show}
        onClose={handleCloseModal}
        title="Eliminar Setting"
        primaryText="Confirmar"
        secondaryText="Cancelar"
        onClickSecondary={handleCloseModal}
        onClickPrimary={handleConfirmDelete}
      >
        <Typography variant="body1">
          ¿Está seguro que desea eliminar el setting <strong>{modalDelete.name}</strong>?
        </Typography>
      </DefaultModal>
    </div>
  );
};

export default SettingsView;
